<template>
<div>
<div class="content_card_content" >



<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">

<ContentHeader :title="headertitle"  :url="url" :show_button="true"  icon="arrow-left" buttontype="danger" :label="label" :urlparams="urlparams"></ContentHeader>

<form @submit.prevent="submitForm" class="mt-4">
<div class="grid">

<div class="col-12 md:col-6">
<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>
</div>

<div class="col-12 md:col-6">
<InputTextValidate :data="fields[1]" :fieldindex="1" @emitValue="inputValueEmitted"></InputTextValidate>
</div>

<div class="col-12 md:col-6">
<InputTextValidate :data="fields[2]" :fieldindex="2" @emitValue="inputValueEmitted"></InputTextValidate>
</div>

<div class="col-12 md:col-6">
<InputTextValidate :data="fields[3]" :fieldindex="3" @emitValue="inputValueEmitted"></InputTextValidate>
</div>

<div class="col-12 md:col-6">
<InputTextValidate :data="fields[4]" :fieldindex="4" @emitValue="inputValueEmitted"></InputTextValidate>
</div>

<div class="col-12 md:col-6">
<InputTextValidate :data="fields[5]" :fieldindex="5" @emitValue="inputValueEmitted"></InputTextValidate>
</div>


<!--
<div class="col-12 md:col-12">
<h2 class="text-primary">{{$store.state.languages.lang_phrases.ozel_nitelikler}}</h2>
<hr>
</div>




<div class="col-12 md:col-6" v-for="(attribute,index) in customattribute_fields">

<template v-if="attribute.type=='select'">
<InputSelectValidate :data="customattribute_fields[index]" :fieldindex="index" @emitValue="attributeInputValueEmitted"></InputSelectValidate>
</template>

<template v-if="attribute.type=='switch'">
<InputSwitchValidate :data="customattribute_fields[index]" :fieldindex="index" @emitValue="attributeInputValueEmitted"></InputSwitchValidate>
</template>

<template v-if="attribute.type=='number'">
<InputNumberValidate :data="customattribute_fields[index]" :fieldindex="index" @emitValue="attributeInputValueEmitted" ></InputNumberValidate>
</template>

<template v-if="attribute.type=='text'">
<InputTextValidate :data="customattribute_fields[index]" :fieldindex="index" @emitValue="attributeInputValueEmitted"></InputTextValidate>
</template>


</div>
-->


</div>










<div class="flex justify-content-end flex-wrap mt-3">
 <Button :label="$store.state.languages.lang_phrases.kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>



</form>

</template>


</div>
</div>
</template>

<script>
export default {

  name: 'CreateSupplier',

  data () {
    return {   
    	loading:true,
    	custom_attributes:[],
    	item:null,
    	customattribute_fields:[],
    	fields:[
	      {
	        title:"Tedarikçi İsmi",
	        key:"name",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:250,
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Tedarikçi Kodu",
	        key:"suppliercode",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:250,
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Yetkili İsim",
	        key:"username",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:250,
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Yetkili Email",
	        key:"email",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:250,
	        is_required:true,
	        has_error:false,
	        is_email:true,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Yetkili Telefon",
	        key:"phone",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:250,
	        is_required:false,
	        has_error:false,
	        is_email:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Yetkili Görevi",
	        key:"position",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:250,
	        is_required:false,
	        has_error:false,
	        is_email:false,
	        error_message:null,
	        show:true,
	      },

      ]
    }
  },
  computed:
  {
  	headertitle()
  	{
  		if(this.item)
  		{
  			if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="brand")
  			{
  				return this.item.name + " - "+this.$store.state.languages.lang_phrases.yeni_tedarikci
  			}
  			if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="project")
  			{
  				return this.item.brand.name + " - "+this.item.name+" Projesi - " +this.$store.state.languages.lang_phrases.yeni_tedarikci
  			}
  			if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="flow")
  			{
  				return this.item.brand.name + " - "+this.item.name+" Akışı - "+this.$store.state.languages.lang_phrases.yeni_tedarikci
  			}
  		}
  	},
  	url()
  	{
  		if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="brand")
			{
				return 	"BrandSuppliers"
			}
			if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="project")
			{
				return 	"ProjectSuppliers"
			}
			if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="flow")
			{
				return 	"FlowSuppliers"
			}
  	},
  	urlparams()
  	{
  		return {id:this.item.id}
  	},
  	label()
  	{
  		if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="brand")
			{
				return 	this.$store.state.languages.lang_phrases.markaya_don
			}
			if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="project")
			{
				return 	this.$store.state.languages.lang_phrases.projeye_don
			}
			if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="flow")
			{
				return 	this.$store.state.languages.lang_phrases.asamaya_don
			}
  	},
  },
  async mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
  		this.loading = await true
  		let createsupplierbackhistoryobj = await this.$store.state.suppliers.createsupplierbackhistoryobj
  		this.custom_attributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$route.params.id)
  		console.log(createsupplierbackhistoryobj)
	  	if(createsupplierbackhistoryobj.item=="brand")
	  	{
	  		this.item = await this.generalApiGet("brand/"+createsupplierbackhistoryobj.id) 
	  	}
	  	if(createsupplierbackhistoryobj.item=="project")
	  	{
	  		this.item = await this.generalApiGet("project/"+createsupplierbackhistoryobj.id) 
	  	}
	  	if(createsupplierbackhistoryobj.item=="flow")
	  	{
	  		this.item = await this.generalApiGet("flow/"+createsupplierbackhistoryobj.id) 
	  	}

	  	if(!createsupplierbackhistoryobj.item)
	  	{
	  		await this.$router.push({name:"Brands"})
	  	}

	  	/*
	  	for(let attribute of this.custom_attributes)
	  	{
	  		let obj = await {
					title:attribute.name,
					key:attribute.id,
					has_error:false,
					value:null,
					error_message:null,					
	        show:true,
	  		}
	  		if(attribute.type=="string")
	  		{
	  			obj.type = await "text"
	  		}
	  		if(attribute.type=="number")
	  		{
	  			obj.type = await "number"
	  		}
	  		if(attribute.type=="boolean")
	  		{
	  			obj.type = await "switch"
	  		}
	  		if(attribute.type=="select")
	  		{
	  			obj.type = await "select"
	  			obj.options = await attribute.options
	  		}

	  		await this.customattribute_fields.push(obj)
	  	}
	  	*/


	  	this.loading = await false
  	},
  	submitForm()
    {
    		//console.log(this.$store.state.suppliers.createsupplierbackhistoryobj.item)
    		//return false
        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
        	this.submit()
          
        }
        console.log(validated)
    },
    inputValueEmitted(data)
    { 
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false   
      if(data.index==1)  
      {
      	if(data.value)
      	{
      		this.fields[3].show = true
      	}
      	else
      	{
      		this.fields[3].show = false
      	}
      }
    },
    attributeInputValueEmitted(data)
    {
    	this.customattribute_fields[data.index].value = data.value 
      this.customattribute_fields[data.index].has_error = false 
    },
    submit()
    {       
      let formdata = this.createFormData(JSON.parse(JSON.stringify(this.fields)))
      //formdata.append("brand_id",this.$route.params.id)


      console.log(this.$store.state.suppliers.createsupplierbackhistoryobj); 

      if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="brand")
			{
				formdata.append("submission_type","brand") 
				formdata.append("brand_id",parseInt(this.$store.state.suppliers.createsupplierbackhistoryobj.id)) 
			}
			if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="project")
			{
				formdata.append("submission_type","project") 
				formdata.append("project_id",parseInt(this.$store.state.suppliers.createsupplierbackhistoryobj.id))
			}
			if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="flow")
			{
				formdata.append("submission_type","flow") 
				formdata.append("flow_id",parseInt(this.$store.state.suppliers.createsupplierbackhistoryobj.id))
			}



   
      //formdata.append("data",JSON.stringify(this.fields))
      this.generalSubmission(formdata,"flow/submit_single_supplier",this.afterSubmit)
    },
    afterSubmit(response)
    {
    	if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="brand")
			{
				
				this.$router.push({ name:  "BrandSuppliers", params: {id:this.item.id} }) 
			}
			if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="project")
			{
				
				this.$router.push({ name:  "ProjectSuppliers", params: {id:this.item.id} }) 
			}
			if(this.$store.state.suppliers.createsupplierbackhistoryobj.item=="flow")
			{
				
				this.$router.push({ name:  "FlowSuppliers", params: {id:this.item.id} }) 
			}



        console.log(response)
        if(response.status==400)
        {
            this.showerror = true
            this.errormessage = response.data.errors[0].message
        } 
        else
        {
        	//this.$router.push({ name: 'Project', params: { id:response.data.id } })
        }
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>